import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { WeeklyMaintenanceSection } from './components/WeeklyMaintenanceSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { WhyChooseSection } from './components/WhyChooseSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-charcoal bg-white selection:bg-brand-red selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <WeeklyMaintenanceSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <GallerySection data-id="element-7" />
        <ServiceAreaSection data-id="element-8" />
        <WhyChooseSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <CTABanner data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}